import AppNavigation from "./AppNavigation";
export const navigationReducer = (state = null, action) => {
  const newState = AppNavigation.router.getStateForAction(action, state);
  // return null
  return newState || state;
};
